import { BoxProps, VStack } from "@chakra-ui/react";

interface ExportRowProps extends BoxProps {
  title?: string;
}

export default function ExportRow({ title, children, ...rest }: ExportRowProps) {
  return (
    <VStack title={title} {...rest}>
      {children}
    </VStack>
  );
}
